module.exports = __webpack_public_path__ + "static/media/ip-logo.23906932.png";